module.exports = __webpack_public_path__ + "static/media/suswan_joglekar.83babad4.png";